import React, { useEffect } from 'react';
//Context
import { LlamadasProvider, useLlamadas } from './LlamadasContext';
//Components
import NuevoTipoLlamada from './NuevoTipoLlamada';
import EditarTipoLlamada from './EditarTipoLlamada';
import LlamadasAcordeon from './LlamadasAcordeon';
import ConfirmModal from '../../components/ConfirmModal';
//Material-UI
import { Snackbar, TextField, IconButton } from '@material-ui/core';
//Icons
import { Check } from 'tabler-icons-react';
import SearchIcon from '@material-ui/icons/Search';
import ClearIcon from '@material-ui/icons/Clear';
//Styles
import '../../styles/llamadas.css';
import '../../App.css';

function Llamadas() {
    const {
        getInfo,
        snackbar,
        setSnackbar,
        snackbarText,
        searchText,
        setSearchText,
        deleteConfirm,
        setDeleteConfirm,
        deleteCallType,
    } = useLlamadas();

    useEffect(() => {
        getInfo('tiposllamada/Listado');
    }, [getInfo]);

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') return;
        setSnackbar(false);
    };

    return (
        <div className="llamadas-page">
            <Snackbar
                open={snackbar}
                autoHideDuration={3000}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <div className="app-notif app-notif--success">
                    <Check size={20} strokeWidth={2} color="#fff" />
                    <span className="app-notif__msg">{snackbarText}</span>
                    <div className="app-notif__progress" />
                </div>
            </Snackbar>

            <div className="llamadas-header">
                <div className="llamadas-header-left">
                    <h1 className="titulo">Tipos de llamadas</h1>
                    <p className="desc">
                        Agregar y editar tipos de llamadas, así como la información relacionada a
                        ellos.
                    </p>
                </div>
            </div>

            <div className="llamadas-body">
                <div className="llamadas-card">
                    <div className="llamadas-card-toolbar">
                        <TextField
                            variant="outlined"
                            size="small"
                            value={searchText}
                            onChange={(e) => setSearchText(e.target.value)}
                            placeholder="Buscar..."
                            className="table-search-inline"
                            InputProps={{
                                startAdornment: <SearchIcon fontSize="small" />,
                                endAdornment: (
                                    <IconButton
                                        size="small"
                                        className={
                                            searchText
                                                ? 'table-search-clear-visible'
                                                : 'table-search-clear-hidden'
                                        }
                                        onClick={() => setSearchText('')}
                                    >
                                        <ClearIcon fontSize="small" />
                                    </IconButton>
                                ),
                            }}
                        />

                        <div className="llamadas-card-actions">
                            <NuevoTipoLlamada />
                        </div>
                    </div>
                    <EditarTipoLlamada />
                    <LlamadasAcordeon />
                </div>
            </div>

            <ConfirmModal
                open={!!deleteConfirm}
                onClose={() => setDeleteConfirm(null)}
                onConfirm={() => deleteCallType(deleteConfirm?.tipoLlamada)}
                title="Eliminar tipo de llamada"
            >
                ¿Estás seguro de eliminar <strong>{deleteConfirm?.nombre}</strong>? Esta acción no
                se puede deshacer.
            </ConfirmModal>
        </div>
    );
}

const LlamadasPage = () => (
    <LlamadasProvider>
        <Llamadas />
    </LlamadasProvider>
);

export default LlamadasPage;
